/**
 * Config Actions
 */

import { SET_ADDRESS_LIST, SET_CONFIG, SET_CONFIG_RECRUITMENT, SET_DEFAULT_FIELD, SET_ALL_FIELD_LIST } from 'Actions/types';

export const setAddressList = data => async dispatch => {
  dispatch({
    type: SET_ADDRESS_LIST,
    payload: { ...data },
  });
};

export const setConfig = data => async dispatch => {
  dispatch({
    type: SET_CONFIG,
    payload: data,
  });
};

export const setConfigRecruitment = data => async dispatch => {
  dispatch({
    type: SET_CONFIG_RECRUITMENT,
    payload: data,
  });
};

export const setAllFieldList = data => async dispatch => {
  dispatch({
    type: SET_ALL_FIELD_LIST,
    payload: data,
  });
};

export const setDefaultField = data => async dispatch => {
  dispatch({
    type: SET_DEFAULT_FIELD,
    payload: data,
  });
};
